(function () {
const root = document.querySelector('[data-aromaorgan-tech]');
if (!root || root.dataset.initialized) return;
root.dataset.initialized = 'true';
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
// Header scroll state
const header = document.getElementById('siteHeader');
const navToggle = document.getElementById('navToggle');
const mobileNav = document.getElementById('mobileNav');
const onScroll = () => {
  if (document.body.classList.contains('aroma-scroll-locked')) return;
  header.classList.toggle('is-scrolled', window.scrollY > 40);
};
onScroll();
window.addEventListener('scroll', onScroll, { passive: true });

// Hero linework — a light parallax drift as the page scrolls. Each line
// drifts at its own slightly different rate, so they gently separate
// from one another too, not just from the rest of the page.
const heroLineworkPaths = document.querySelectorAll('.hero__linework path');
if (heroLineworkPaths.length) {
  const PARALLAX_FACTORS = [0.1, 0.17, 0.25];
  let linworkRaf;
  const updateLinworkParallax = () => {
    linworkRaf = null;
    if (document.body.classList.contains('aroma-scroll-locked')) return;
    const y = window.scrollY;
    heroLineworkPaths.forEach((path, i) => {
      const factor = PARALLAX_FACTORS[i % PARALLAX_FACTORS.length];
      path.style.transform = `translateY(${y * factor}px)`;
    });
  };
  updateLinworkParallax();
  window.addEventListener('scroll', () => {
    if (linworkRaf) return;
    linworkRaf = requestAnimationFrame(updateLinworkParallax);
  }, { passive: true });
}

// Nav collapses to the burger menu only when the full set of links,
// the FAQ link and the Buy button no longer fit on a single line —
// never at a fixed breakpoint, so nothing ever wraps to a second line.
const headerInner = header.querySelector('.site-header__inner');

const checkNavFit = () => {
  header.classList.remove('is-collapsed'); // force natural width, no paint happens before we re-decide below
  const fits = headerInner.scrollWidth <= headerInner.clientWidth + 1;
  header.classList.toggle('is-collapsed', !fits);
  if (fits && mobileNav.classList.contains('is-open')) setMobileMenuOpen(false);
};

checkNavFit();
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(checkNavFit);
}

let navResizeRaf;
window.addEventListener('resize', () => {
  cancelAnimationFrame(navResizeRaf);
  navResizeRaf = requestAnimationFrame(checkNavFit);
});

// In Use gallery — manual scroll only, but it loops seamlessly in both
// directions. The track holds 3 copies of the card set; once the user
// scrolls past copy A or C, we silently snap back into copy B by exactly
// one set-width so the loop never visibly resets.
const inUseTrack = document.querySelector('.in-use__track');
if (inUseTrack) {
  const inUseInner = inUseTrack.querySelector('.in-use__track-inner');
  let inUseSetWidth = 0;

  const measureInUse = () => {
    inUseSetWidth = inUseInner.scrollWidth / 3;
    inUseTrack.scrollLeft = inUseSetWidth;
  };

  measureInUse();
  window.addEventListener('resize', measureInUse);

  inUseTrack.addEventListener('scroll', () => {
    if (!inUseSetWidth) return;
    if (inUseTrack.scrollLeft <= 0) {
      inUseTrack.scrollLeft += inUseSetWidth;
    } else if (inUseTrack.scrollLeft >= inUseSetWidth * 2) {
      inUseTrack.scrollLeft -= inUseSetWidth;
    }
  }, { passive: true });

  // Gentle auto-advance — one card, every 7s. Any manual scroll input
  // restarts the timer so it never fights the user mid-gesture.
  const IN_USE_AUTO_INTERVAL = 5000;
  let inUseAutoTimer;

  const inUseCardStep = () => {
    const cards = inUseInner.children;
    return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 0;
  };

  const startInUseAuto = () => {
    clearInterval(inUseAutoTimer);
    inUseAutoTimer = setInterval(() => {
      inUseTrack.scrollBy({ left: inUseCardStep(), behavior: 'smooth' });
    }, IN_USE_AUTO_INTERVAL);
  };

  startInUseAuto();
  ['pointerdown', 'wheel'].forEach((evt) => {
    inUseTrack.addEventListener(evt, startInUseAuto, { passive: true });
  });
}

// Product accordion — "In the Box" / "Characteristics" start collapsed
document.querySelectorAll('.accordion-item').forEach((item) => {
  const trigger = item.querySelector('.accordion-trigger');
  trigger.addEventListener('click', () => {
    const isOpen = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', String(isOpen));
  });
});

// Reveal-on-scroll — a light fade + rise for each section's content
// groups, triggered once as they enter the viewport.
const revealEls = document.querySelectorAll('.reveal');
if (revealEls.length && 'IntersectionObserver' in window) {
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  revealEls.forEach((el) => revealObserver.observe(el));
}

// How It Works — clicking a step swaps the active photo. Steps also
// auto-advance every 15s; any manual click resets that timer.
const howSteps = document.querySelectorAll('.how__step');
const howImages = document.querySelectorAll('.how__media-img');
const HOW_AUTO_INTERVAL = 15000;
let howAutoIndex = 0;
let howAutoTimer;

const setHowStep = (index) => {
  howAutoIndex = index;
  const target = howSteps[index].dataset.step;
  howSteps.forEach((s, i) => s.classList.toggle('is-active', i === index));
  howImages.forEach((img) => img.classList.toggle('is-active', img.dataset.stepImg === target));
};

const startHowAuto = () => {
  clearInterval(howAutoTimer);
  howAutoTimer = setInterval(() => {
    setHowStep((howAutoIndex + 1) % howSteps.length);
  }, HOW_AUTO_INTERVAL);
};

howSteps.forEach((step, index) => {
  step.addEventListener('click', () => {
    setHowStep(index);
    startHowAuto();
  });
});

if (howSteps.length) startHowAuto();

// Fit each wordmark to the available container width.
const fitTextToWidth = (text, container) => {
  if (!text || !container) return () => {};
  return () => {
    text.style.fontSize = '';
    const containerStyle = getComputedStyle(container);
    const availableWidth = container.clientWidth
      - parseFloat(containerStyle.paddingLeft)
      - parseFloat(containerStyle.paddingRight);
    const naturalWidth = text.getBoundingClientRect().width;
    if (naturalWidth === 0) return;
    const currentSize = parseFloat(getComputedStyle(text).fontSize);
    const targetSize = currentSize * (availableWidth / naturalWidth);
    text.style.fontSize = targetSize + 'px';
  };
};

const fitHeroTitle = fitTextToWidth(
  document.querySelector('.hero__title'),
  document.querySelector('.hero__headline')
);
const fitFooterWordmark = fitTextToWidth(
  document.querySelector('.site-footer__wordmark'),
  document.querySelector('.site-footer__inner')
);

const fitAllFluidText = () => {
  fitHeroTitle();
  fitFooterWordmark();
};

fitAllFluidText();
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(fitAllFluidText);
}

let fluidTextRaf;
window.addEventListener('resize', () => {
  cancelAnimationFrame(fluidTextRaf);
  fluidTextRaf = requestAnimationFrame(fitAllFluidText);
});

// Mobile nav toggle
function setMobileMenuOpen(isOpen) {
  mobileNav.classList.toggle('is-open', isOpen);
  header.classList.toggle('is-menu-open', isOpen);
  navToggle.setAttribute('aria-expanded', String(isOpen));
  navToggle.classList.toggle('is-active', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

navToggle.addEventListener('click', () => {
  const isOpen = !mobileNav.classList.contains('is-open');
  setMobileMenuOpen(isOpen);
  if (isOpen) mobileNav.querySelector('a').focus({ preventScroll: true });
});

mobileNav.querySelectorAll('a').forEach((link) => {
  link.addEventListener('click', () => setMobileMenuOpen(false));
});

document.addEventListener('keydown', event => {
  if (navToggle.getAttribute('aria-expanded') !== 'true') return;
  if (event.key === 'Escape') {
    setMobileMenuOpen(false);
    navToggle.focus({ preventScroll: true });
  }
  if (event.key === 'Tab') {
    const controls = [navToggle, ...mobileNav.querySelectorAll('a, button')];
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }
});

const video = root.querySelector('#heroVideo');
if (video) {
  const mobile = window.matchMedia('(max-width: 640px)');
  const syncVideo = () => {
    const poster = mobile.matches ? video.dataset.posterMobile : video.dataset.posterDesktop;
    if (poster) video.poster = poster;
    const src = mobile.matches ? video.dataset.videoMobile : video.dataset.videoDesktop;
    if (reducedMotion.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
    if (src && video.getAttribute('src') !== src) video.src = src;
    if (!reducedMotion.matches) video.play().catch(() => {});
  };
  mobile.addEventListener('change', syncVideo);
  syncVideo();
}

})();
